// Adds .is-visible to any [data-reveal] element when it enters the viewport.
// Composable returns nothing — invoking it from a layout/page on the client
// sets up a single IntersectionObserver shared across the document.

export function useReveal() {
  if (import.meta.server) return

  onMounted(() => {
    const targets = document.querySelectorAll<HTMLElement>('[data-reveal]')
    if (!targets.length) return

    const io = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible')
          io.unobserve(entry.target)
        }
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' })

    targets.forEach((el) => {
      el.classList.add('rod-reveal')
      io.observe(el)
    })
  })
}
